import React from 'react';
import { motion } from 'framer-motion';
export function MethodSection() {
  return <section className="bg-light text-text-light py-20 md:py-28 px-6" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-12" data-id="element-85">
          <div className="space-y-4" data-id="element-86">
            <h2 className="text-3xl md:text-5xl font-serif text-dark-100" data-id="element-87">
              La Pausa Consciente
            </h2>
            <p className="text-xl text-accent font-medium uppercase tracking-widest" data-id="element-88">
              El Mecanismo Único
            </p>
          </div>

          <div className="relative" data-id="element-89">
            {/* Decorative background element */}
            <div className="absolute inset-0 bg-accent/5 rounded-3xl transform -rotate-1" data-id="element-90"></div>

            <div className="relative bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-accent/10 flex flex-col md:flex-row items-center gap-10" data-id="element-91">
              <div className="shrink-0 flex flex-col items-center justify-center w-32 h-32 md:w-40 md:h-40 bg-dark-100 rounded-full text-accent shadow-lg border-4 border-white" data-id="element-92">
                <span className="text-4xl md:text-5xl font-serif font-bold" data-id="element-93">
                  90
                </span>
                <span className="text-sm md:text-base uppercase tracking-wider mt-1" data-id="element-94">
                  Segundos
                </span>
              </div>

              <div className="text-left space-y-4 text-lg text-text-light/80 leading-relaxed" data-id="element-95">
                <p data-id="element-96">
                  La "Pausa Consciente" es un método diseñado específicamente
                  para familias que valoran el apego pero necesitan dormir.
                </p>
                <p data-id="element-97">
                  No es un entrenamiento rígido, es una técnica de observación
                  de{' '}
                  <strong className="text-dark-100 font-bold" data-id="element-98">
                    90 segundos
                  </strong>{' '}
                  que permite al cerebro del bebé conectar sus propios ciclos de
                  sueño mientras tú estás ahí, presente y validando sus
                  necesidades reales sin sobre-intervenir.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}